import React, { useRef, useEffect } from 'react';

const COLORS = ['#111827','#EF1D28','#FB923C','#059669','#DC2626','#D97706','#0891B2','#6B7280'];

export const RichTextToolbar = ({ onFormat }) => {
  const btn = (title, cmd, val, label) => (
    <button title={title} onMouseDown={e => { e.preventDefault(); document.execCommand(cmd, false, val); onFormat && onFormat(); }}
      style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 4, padding: '2px 7px', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#374151', margin: '0 2px' }}>
      {label}
    </button>
  );
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, padding: '6px 8px', background: '#F9FAFB', border: '1px solid #E5E7EB', borderBottom: 'none', borderRadius: '6px 6px 0 0', alignItems: 'center' }}>
      {btn('Bold', 'bold', null, <b>B</b>)}
      {btn('Italic', 'italic', null, <i>I</i>)}
      {btn('Underline', 'underline', null, <u>U</u>)}
      <span style={{ width: 1, height: 18, background: '#E5E7EB', margin: '0 4px' }} />
      {['12','13','14','16','18'].map(s => (
        <button key={s} onMouseDown={e => { e.preventDefault(); document.execCommand('fontSize', false, s === '12' ? '1' : s === '13' ? '2' : s === '14' ? '3' : s === '16' ? '4' : '5'); }}
          style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: 4, padding: '2px 6px', cursor: 'pointer', fontSize: 11, color: '#6B7280', margin: '0 1px' }}>{s}</button>
      ))}
      <span style={{ width: 1, height: 18, background: '#E5E7EB', margin: '0 4px' }} />
      {COLORS.map(c => (
        <div key={c} onMouseDown={e => { e.preventDefault(); document.execCommand('foreColor', false, c); }}
          style={{ width: 16, height: 16, background: c, borderRadius: 3, cursor: 'pointer', border: '1px solid #E5E7EB', margin: '0 1px' }} />
      ))}
    </div>
  );
};

export const RichTextArea = ({ value, onChange, placeholder, minHeight = 80 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) {
      ref.current.innerHTML = value || '';
    }
  }, []);

  const handleInput = () => {
    if (ref.current) onChange(ref.current.innerHTML);
  };

  return (
    <div>
      <RichTextToolbar />
      <div
        ref={ref}
        contentEditable
        onInput={handleInput}
        data-placeholder={placeholder}
        style={{
          minHeight, padding: '8px 12px', border: '1px solid #E5E7EB', borderRadius: '0 0 6px 6px',
          fontSize: 13, lineHeight: 1.6, outline: 'none', background: 'white',
          boxSizing: 'border-box', width: '100%',
        }}
        suppressContentEditableWarning
      />
    </div>
  );
};

// Simple plain textarea with optional bold button
export const SmartTextarea = ({ value, onChange, placeholder, rows = 3 }) => (
  <textarea
    value={value || ''}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
    rows={rows}
    style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #E5E7EB', borderRadius: 6, fontSize: 13, resize: 'vertical', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: 1.5 }}
  />
);
